import { useState } from "react";

const CREDENTIALS = [
  { username: "devuser1", password: "Kx9#mLqP2" },
  { username: "devuser2", password: "Tz4$wRnJ7" },
  { username: "devuser3", password: "Bv6!hYcQ5" },
];

const STORAGE_KEY = "site_gate_auth";

function isAuthenticated() {
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export default function SiteGate({ children }) {
  const [authed, setAuthed] = useState(isAuthenticated);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  if (authed) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    const match = CREDENTIALS.find(
      (c) => c.username === username && c.password === password
    );
    if (match) {
      localStorage.setItem(STORAGE_KEY, "1");
      setAuthed(true);
    } else {
      setError("Invalid credentials");
      setPassword("");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <form
        onSubmit={handleSubmit}
        data-testid="site-gate-form"
        style={{
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: 6,
          padding: "32px 28px",
          width: 320,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          style={{
            margin: "0 0 20px",
            fontSize: 18,
            fontWeight: 600,
            color: "#333",
            textAlign: "center",
          }}
        >
          Site Access
        </h2>

        <label style={{ display: "block", marginBottom: 12 }}>
          <span style={{ fontSize: 13, color: "#555", display: "block", marginBottom: 4 }}>
            Username
          </span>
          <input
            data-testid="site-gate-username"
            type="text"
            value={username}
            onChange={(e) => { setUsername(e.target.value); setError(""); }}
            autoFocus
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "1px solid #ccc",
              borderRadius: 4,
              fontSize: 14,
              boxSizing: "border-box",
            }}
          />
        </label>

        <label style={{ display: "block", marginBottom: 16 }}>
          <span style={{ fontSize: 13, color: "#555", display: "block", marginBottom: 4 }}>
            Password
          </span>
          <input
            data-testid="site-gate-password"
            type="password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(""); }}
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "1px solid #ccc",
              borderRadius: 4,
              fontSize: 14,
              boxSizing: "border-box",
            }}
          />
        </label>

        {error && (
          <div
            data-testid="site-gate-error"
            style={{ color: "#c00", fontSize: 13, marginBottom: 12, textAlign: "center" }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          data-testid="site-gate-submit"
          style={{
            width: "100%",
            padding: "9px 0",
            background: "#444",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            fontSize: 14,
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Enter
        </button>
      </form>
    </div>
  );
}
